// addJobOrActivityUtils.ts
// Utility functions for the add job or add activity forms.


// Add hour to the start time default value as end time
export const addHourToStartTime = (time: string): string => {

    // Get the time value
    const [h, m] = time.split(':').map((v) => Number(v));

    // Return if hour and minute is not in the right format
    if (!Number.isFinite(h) || !Number.isFinite(m)) {
        return time;
    }

    // Calculate the total minutes of the new end time
    const totalMinutes = (h * 60 + m + 60) % (24 * 60);

    // Get the new hours and minutes
    const newH = Math.floor(totalMinutes / 60);
    const newM = totalMinutes % 60;

    return `${String(newH).padStart(2, '0')}:${String(newM).padStart(2, '0')}`;
};


// Get the selected start time from the linked item
export const getSelectedStartTime = (linkedItem?: { selectedTime?: unknown }): string | undefined => {
    if (typeof linkedItem?.selectedTime === 'string' && linkedItem.selectedTime.trim() !== '') {
        return linkedItem.selectedTime;
    }

    return undefined;
};


// Get the selected end time from the linked item - only set when the "schedule appointments for
// the whole day by default" setting computed an explicit end time (employee timetable or display
// time fallback). When absent, the form falls back to start time + 1 hour, as before.
export const getSelectedEndTime = (linkedItem?: { selectedEndTime?: unknown }): string | undefined => {
    if (typeof linkedItem?.selectedEndTime === 'string' && linkedItem.selectedEndTime.trim() !== '') {
        return linkedItem.selectedEndTime;
    }

    return undefined;
};


// Get the selected date from the linked item
export const getSelectedDate = (linkedItem?: { selectedDate?: unknown }): string | undefined => {
    if (typeof linkedItem?.selectedDate === 'string' && linkedItem.selectedDate.trim() !== '') {
        return linkedItem.selectedDate;
    }

    return undefined;
};


// Get the selected resource from the linked item
export const getSelectedResource = (linkedItem?: { selectedResource?: unknown }): string | undefined => {
    if (linkedItem?.selectedResource !== undefined && linkedItem?.selectedResource !== null && linkedItem.selectedResource !== '') {
        return String(linkedItem.selectedResource);
    }

    return undefined;
};

// Get the selected equipment from the linked item, set when a job is added on an equipment row
export const getSelectedEquipment = (linkedItem?: { selectedEquipment?: unknown }): string | undefined => {
    if (linkedItem?.selectedEquipment !== undefined && linkedItem?.selectedEquipment !== null && linkedItem.selectedEquipment !== '') {
        return String(linkedItem.selectedEquipment);
    }

    return undefined;
};
